import React, { Component } from "react";
import { HashLink as Link } from 'react-router-hash-link';

class OurHistory extends Component {
    render() {
        const imagePart = (
            <div className="col-lg-6 col-md-8">
                <div className="pr-0 pr-lg-5">
                    <img className="img-fluid" src={process.env.PUBLIC_URL + '/assets/images/stemma.png'} alt="about" />
                </div>
            </div>
        );

        const descPart = (
            <div className="col-lg-6 col-md-10">
                <div className='block text-center mt-5 mt-lg-0'>
                    <div className="col-md-12 text-center">
                        <h2 className="section-heading h1 text-dark mb-15">La nostra storia</h2>
                    </div>
                    <p className="mt-25">
                        La Società Sportiva Dilettantistica Fiorentina Baseball viene fondata il 13 Febbraio 1981
                        dalla fusione delle Società Firenze B.C. e Lions B.S.C..
                        </p>
                    <p className="mt-25">
                        Da quel momento ha sempre rappresentato il capoluogo toscano nel baseball nazionale
                        esprimendone, nel suo contesto territoriale, il più alto livello: nel suo palmares sono
                        presenti uno Scudetto vinto nel 1949 come Firenze B.S.C., Campioni d’Italia cat. Allievi nel
                        1979 e una Coppa Italia vinta nel 1985.
                        </p>
                    <p className="mt-25">
                        Attualmente la Società partecipa con le proprie squadre Seniores ai campionati di Serie A
                        baseball, di Serie B softball, di serie C baseball con la Franchigia Firenze e ai campionati
                        regionali con tutte le categorie Juniores sia di baseball che di softball.
                        </p>
                    <p className="mt-25">
                        Da non molto la Fiorentina Baseball ha riattivato il suo settore giovanile e sta portando
                        avanti un progetto innovativo centrato sui giovani, in grado di offrire loro un percorso
                        completo adatto alle attitudini di ognuno, dal minibaseball alle categorie Seniores.
                        </p>

                    <p className="mt-25">
                        Per saperne di più continua a legger la nostra storia cliccando sul link sottostante.
                        </p>

                        <Link to='/history_extended' className="btn btn-primary mt-10 mr-3 mr-md-4 initiate-scripts text-white" spy="true" smooth="true">Continua...</Link>
                </div>
            </div>
        )
        return (
            <section className='section cm-about-us pt-80' id="history">
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        {imagePart}
                        {descPart}
                    </div>
                </div>
            </section>
        );
    }
}

export default OurHistory;